import { apiRequest } from "./apiClient";
import type { BusinessUnitOption } from "../types/businessUnit";

type BackendBusinessUnitsResponse = {
  readonly success: boolean;
  readonly data: readonly BusinessUnitOption[];
};

/** GET /business-units — active authorization BUs (code + name), TTL-cached server-side. */
export async function listActiveBusinessUnits(): Promise<readonly BusinessUnitOption[]> {
  const response = await apiRequest(
    "/business-units",
    { method: "GET" },
    { requiresAuth: true }
  );
  const json = (await response.json()) as BackendBusinessUnitsResponse;
  return Array.isArray(json.data) ? [...json.data] : [];
}
